/**
 * 创建a标签跳转
 *
 * @param {string} str - 跳转地址。
 * @param {boolen} target - 是否新窗口打开
 */
export function jumpNewPage(str, target = true) {
  if (!str) {
    return str;
  }
  const link = document.createElement("a");
  link.href = str;
  if (target) link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
